import amplitudeEventNames from '@/consts/analytics/analyticsEventNames';
import analyticsEventProperties from '@/consts/analytics/analyticsEventProperties';
import deviceTypesService from '@/services/device/deviceTypesService';
import {selectCurrentProductInfo} from '@/state/selectors/device';
import {getState} from '@/state/store';

import amplitude from './amplitude';

const trackDeviceEvent = (eventType, serialNumber, deviceType, properties) => {
    const modelName = deviceTypesService.getDeviceModelByType(deviceType);

    amplitude.trackEvent({eventType, serialNumber, modelName, properties});
};

const trackDeviceFromStateEvent = (eventType, properties) => {
    const {deviceSerialNumber, type} = selectCurrentProductInfo(getState());

    trackDeviceEvent(eventType, deviceSerialNumber, type, properties);
};

const trackAddNewDeviceClick = () => {
    amplitude.trackWithSource(amplitudeEventNames.ADD_NEW_DEVICE_CLICKED);
};

const trackPairDeviceClick = (serialNumber, deviceType) => {
    trackDeviceEvent(amplitudeEventNames.PAIR_DEVICE_CLICKED, serialNumber, deviceType);
};

const trackChromeDownloadButtonClick = () => {
    amplitude.trackWithSource(amplitudeEventNames.CHROME_DOWNLOAD_BUTTON_CLICKED);
};

const trackStartWithBluefyClick = (deviceType, deviceSerialNumber) => {
    trackDeviceEvent(amplitudeEventNames.START_WITH_BLUEFY_CLICKED, deviceSerialNumber, deviceType);
};

const trackRenameDeviceScreen = (deviceType, deviceSerialNumber) => {
    trackDeviceEvent(amplitudeEventNames.RENAME_MY_DEVICE_VIEWED, deviceSerialNumber, deviceType);
};

const trackRenameDeviceSave = (deviceType, deviceSerialNumber) => {
    trackDeviceEvent(amplitudeEventNames.RENAME_DEVICE, deviceSerialNumber, deviceType);
};

const trackUnregisterDeviceClick = (deviceSerialNumber, type, success) => {
    trackDeviceEvent(amplitudeEventNames.UNREGISTER_DEVICE_CLICKED, deviceSerialNumber, type, {
        [analyticsEventProperties.SUCCESS]: success,
    });
};

const trackUnregisterHolderClick = (deviceSerialNumber, type, success) => {
    const holderDefaultData = deviceTypesService.getDeviceTypesDataByType(type);
    const modelName = holderDefaultData?.modelName;

    amplitude.trackEvent({
        eventType: amplitudeEventNames.UNREGISTER_DEVICE_CLICKED,
        serialNumber: deviceSerialNumber,
        modelName,
        properties: {
            [analyticsEventProperties.SUCCESS]: success,
        },
    });
};

export default {
    trackAddNewDeviceClick,
    trackDeviceFromStateEvent,
    trackPairDeviceClick,
    trackStartWithBluefyClick,
    trackRenameDeviceScreen,
    trackRenameDeviceSave,
    trackUnregisterDeviceClick,
    trackUnregisterHolderClick,
    trackChromeDownloadButtonClick,
};
